import {computed, Injectable, signal} from '@angular/core';
import {BaseDesignBlockFile} from "../types/design-block-files.types";

@Injectable({
  providedIn: 'root'
})
export class DbFilesStateService {
  private _dbFilesState = signal<Array<BaseDesignBlockFile>>([]);
  public dbFilesState = this._dbFilesState.asReadonly();
  public readonly dbFileIds = computed(() =>
    this._dbFilesState()
      .map(file => file.file.id)
      .sort((a, b) => a - b)
  );

  public setDbFilesState(files: Array<BaseDesignBlockFile>): void {
    this._dbFilesState.set(files);
  }

  public updateDbFilesState(file: BaseDesignBlockFile): void {
    this._dbFilesState.update(files => {
      const existingFileIndex = files.findIndex(f => f.id === file.id);

      return existingFileIndex !== -1 ?
        files.map(f => f.id === file.id ? file : f) :
        [...files, file];
    });
  }

  public deleteFileById(fileId: number): void {
    this._dbFilesState.update(files =>
      files.filter(file => file.id !== fileId)
    );
  }

  public resetDbFilesState(): void {
    this._dbFilesState.set([]);
  }
}
